import { cn } from "@/lib/utils";

function Skeleton({
  className,
  isLoading,
  children,
  ...props
}: React.ComponentProps<"div"> & { isLoading?: boolean }) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "bg-skeleton-primary animate-pulse rounded-md",
        !isLoading && "bg-transparent animate-none",
        className
      )}
      {...props}
    >
      <div data-loading={isLoading} className="data-[loading=true]:invisible">
        {children}
      </div>
    </div>
  );
}

export { Skeleton };
